export function getRoleLabel(role: string): string {
  if (role === "staff") return "Staff Manager";
  if (role === "staff-coordinator") return "Staff Coordinator";
  if (role === "admin") return "Admin";
  if (role === "ops") return "Operations";
  return role;
}
